import {FirebaseApp} from 'firebase/app'
import {getBytes, getStorage, ref, connectStorageEmulator} from 'firebase/storage'
import {FirebaseStorage} from '@firebase/storage'
// import {isDemoMode} from '@/services/infrastructure/firebase.service'
import {getSelectedOrgId} from '@/tenants/org.service'
import {ReportMeta} from '@/types/ReportMeta'
import {get} from '@/services/infrastructure/api.service'
import {DocumentMeta} from '@/types/transaction/DocumentMeta'
import {isDemoMode} from '@/services/infrastructure/firebase.service'

let storage: FirebaseStorage

const init = (app: FirebaseApp) => {
    storage = getStorage(app)

    if (isDemoMode()) {
        storage = getStorage(app, 'gs://demo-tritt.appspot.com')
        connectStorageEmulator(storage, 'localhost', 9199)
    }
}

const useStorageService = () => {
    return {
        init,
        storage
    }
}

enum FilePath {
    ATTACHMENTS = 'attachments',
    SAFT_EXPORTS = 'saft-exports'
}

const downloadBytes = async (filename: String) => {
    const {storage} = useStorageService()
    const orgId = getSelectedOrgId()
    const storageRef = ref(storage, encodeURI(`pracsys/${orgId}/${filename}`))
    return await getBytes(storageRef)
}

const downloadVatReport = async (documentMeta: DocumentMeta) => {
    const bytes = await downloadBytes(documentMeta.filename)
    const link = document.createElement('a')
    const blob = new Blob([bytes], {type: documentMeta.contentType})
    link.href = window.URL.createObjectURL(blob)
    link.download = documentMeta.filename
    link.click()
}

const downloadVatReportPdf = async (reportPdf: string, fileName: string) => {
    const bytes = await downloadBytes(reportPdf)
    const link = document.createElement('a')
    const blob = new Blob([bytes], {type: 'application/pdf'})
    link.href = window.URL.createObjectURL(blob)
    link.download = fileName
    link.click()
}

const download = async (reportMeta: ReportMeta) => {
    const bytes = await downloadBytes(reportMeta.documentMeta.uuid)
    const link = document.createElement('a')
    const blob = new Blob([bytes], {type: reportMeta.documentMeta.contentType})
    link.href = window.URL.createObjectURL(blob)
    link.download = reportMeta.documentMeta.filename
    link.click()
}


const getReportMetas = async (): Promise<ReportMeta[]> => { return await get('/report-meta', {}) ?? []}
const getTransactionDocuments = async (transactionUuid: string): Promise<Array<DocumentMeta>> => await get('/documents/transaction', {
    transactionUuid
}) ?? []

const getDocumentUuid = (uri: string): string => {
    const t = uri.split('/')
    return t[t.length - 1]
}

const getDocumentUri = (uuid: string): string => {
    const orgId = getSelectedOrgId()
    return `pracsys/${orgId}/${uuid}`
}
const getDocumentMeta = async (documentUuid: string): Promise<DocumentMeta | undefined> => get('/documents/' + documentUuid, {})

export {useStorageService, downloadBytes, FilePath, getReportMetas, download, getTransactionDocuments, getDocumentMeta, getDocumentUri, getDocumentUuid, downloadVatReport, downloadVatReportPdf}